import { render } from "./AdminLogs.vue?vue&type=template&id=6f794f2c&scoped=true"
import script from "./AdminLogs.vue?vue&type=script&lang=js"
export * from "./AdminLogs.vue?vue&type=script&lang=js"

import "./AdminLogs.vue?vue&type=style&index=0&id=6f794f2c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f794f2c"]])

export default __exports__